import { render } from "./GetInTouchPopup.vue?vue&type=template&id=44869f3c&scoped=true"
import script from "./GetInTouchPopup.vue?vue&type=script&lang=js"
export * from "./GetInTouchPopup.vue?vue&type=script&lang=js"

import "./GetInTouchPopup.vue?vue&type=style&index=0&id=44869f3c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44869f3c"]])

export default __exports__